/**
 * Google Ads Conversion Tracking Utilities
 * 
 * Handles conversion events for Google Ads campaigns
 */

// Track if conversion was already sent to prevent duplicates
const sentConversions = new Set();

/**
 * Track a subscription conversion event
 * @param {string} transactionId - Unique transaction/subscription ID to prevent duplicates
 * @param {number} value - Value in BRL (default: 1.0)
 */
export const trackSubscriptionConversion = (transactionId = null, value = 1.0) => {
  // Prevent duplicate conversions
  const conversionKey = transactionId || `conversion_${Date.now()}`;
  
  if (sentConversions.has(conversionKey)) {
    console.log('[GTAG] Conversion already tracked:', conversionKey);
    return;
  }
  
  // Check if gtag is available
  if (typeof window.gtag !== 'function') {
    console.warn('[GTAG] Google Tag not loaded');
    return;
  }
  
  try {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-18172983228/y66xCIbVt7McELzvxtlD',
      'value': value,
      'currency': 'BRL',
      'transaction_id': transactionId
    });
    
    sentConversions.add(conversionKey);
    console.log('[GTAG] Subscription conversion tracked:', conversionKey, 'Value:', value);
  } catch (error) {
    console.error('[GTAG] Error tracking conversion:', error);
  }
};

/**
 * Track a generic event
 * @param {string} eventName - Event name
 * @param {object} params - Event parameters
 */
export const trackEvent = (eventName, params = {}) => {
  if (typeof window.gtag !== 'function') {
    console.warn('[GTAG] Google Tag not loaded');
    return;
  }
  
  try {
    window.gtag('event', eventName, params);
    console.log('[GTAG] Event tracked:', eventName, params);
  } catch (error) {
    console.error('[GTAG] Error tracking event:', error);
  }
};

export default {
  trackSubscriptionConversion,
  trackEvent
};
